<template>
  <div id="jobdescription">
    <!-- BEGIN Popup confirm delete desc -->
    <confirm-delete-popup
      :popup-state="confirmDeleteDesc"
      :warning-condition="postesCount > 0"
      @close="changeDeletePopupState(-1)"
      @confirmation="deleteDesc(toDelete)"
    >
      <template #title>
        Supprimer
        {{
          isJobDescriptionType
            ? 'la fiche de poste'
            : 'le référentiel de formation'
        }}
        <br>"{{ (toDelete || {}).name }}"
      </template>
      <template #message>
        Êtes-vous sûr de vouloir supprimer
        {{
          isJobDescriptionType
            ? 'la fiche de poste'
            : 'le référentiel de formation'
        }}
        <br>
        "{{ (toDelete || {}).name }}" ?
      </template>
      <template #warning>
        Attention
        {{
          isJobDescriptionType
            ? 'cette fiche de poste est utilisée'
            : 'ce référentiel est utilisé'
        }}
        pour {{ postesCount }} {{ isJobDescriptionType ? 'poste' : 'formation'
        }}{{ postesCount === 1 ? '' : 's' }}.
      </template>
      <template #confirmTitle>
        {{
          isJobDescriptionType
            ? 'Fiche de poste supprimée'
            : 'Référentiel de formation supprimé'
        }}
      </template>
      <template #confirmMessage>
        {{ isJobDescriptionType ? 'La fiche de poste' : 'Le référentiel' }}
        "{{ (toDelete || {}).name }}" a bien été supprimé{{
          isJobDescriptionType ? 'e' : ''
        }}.
      </template>
    </confirm-delete-popup>
    <!-- END Popup confirm delete template -->

    <!-- BEGIN Popup confirm transfer -->
    <popup
      :opened="transferSuccess"
      @close="changeTransferSuccessPopupState(false)"
    >
      <!-- Screen to ask a confirmation to close current evaluation -->
      <div class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto">
        <h3 class="mb-10 text-pink-600">
          {{
            isJobDescriptionType
              ? 'Fiche de poste ajoutée'
              : 'Référentiel de formation ajouté'
          }}
          !
        </h3>
        <h6 class="text-indigo-600 mb-10">
          {{
            isJobDescriptionType
              ? 'La fiche de poste'
              : 'Le référentiel de formation'
          }}
          « {{ transferedDesc }} » a bien été ajouté{{
            isJobDescriptionType ? 'e' : ''
          }}
          à votre bibliothèque personnelle.
          {{
            !$freeParticulier() ? 'Vous pouvez désormais la personnaliser.' : ''
          }}
        </h6>
        <illustration
          name="basket"
          class="mt-12 mx-auto"
        />
      </div>
    </popup>
    <!-- END Popup confirm transfer -->

    <!-- Popup fiche de poste -->
    <popup-job-desc
      :id="shownJobId"
      :show="showJobDesc"
      :opened-from-edit-button="openFromEditButton && permissions.persoEdit"
      @mutateShow="
        (newValue) => {
          showJobDesc = newValue;
          !newValue && openFromEditButton ? load_descs(true) : null;
        }
      "
      @mutateId="
        (newValue) => {
          shownJobId = newValue;
        }
      "
    />
    <!-- END Popup fiche de poste -->

    <!-- Popup référentiel de formation -->
    <popup-ref-formation
      :id="shownJobId"
      :show="showRefForm"
      :opened-from-edit-button="openFromEditButton && permissions.persoEdit"
      @mutateShow="
        (newValue) => {
          showRefForm = newValue;
          !newValue && openFromEditButton ? load_descs(true) : null;
        }
      "
      @mutateId="
        (newValue) => {
          shownJobId = newValue;
        }
      "
    />
    <!-- END Popup référentiel de formation -->

    <!-- Popup fiche ROME -->
    <popup-rome-desc
      :id="shownJobId"
      :show="showRomeDesc"
      :opened-from-edit-button="openFromEditButton && permissions.persoEdit"
      @mutateShow="
        (newValue) => {
          showRomeDesc = newValue;
          !newValue && openFromEditButton ? load_descs(true) : null;
        }
      "
      @mutateId="
        (newValue) => {
          shownJobId = newValue;
        }
      "
    />
    <!-- END Popup fiche ROME -->

    <module-header
      :module-name="
        isJobDescriptionType ? 'Fiches de poste' : 'Référentiels de formation'
      "
      illustration-name="fiche_de_poste"
    >
      <template #description>
        {{
          isJobDescriptionType
            ? 'Retrouvez dans la bibliothèque commune des fiches de poste'
            : 'Retrouvez ici les référentiels de formation.'
        }}
        <br>
        {{
          isJobDescriptionType
            ? 'et importez celles qui correspondent à votre structure dans votre bibliothèque personnelle.'
            : 'Vous pouvez en créer de nouveaux, les modifier, ou en importer depuis la bibliothèque commune.'
        }}
      </template>
    </module-header>

    <popup
      :opened="restrictedDescsPopup"
      @close="restrictedDescsPopup = false"
    >
      <div class="my-4 mx-6">
        <p>
          Pour accéder à l'ensemble des fiches disponibles dans la bibliothèque commune,
          <router-link
            :to="{name: 'Subscriptionchoice'}"
            class="underline text-indigo-600"
          >
            faites évoluer votre abonnement.
          </router-link>
        </p>
      </div>
    </popup>

    <div v-if="allowed && (permissions.persoList || permissions.commonList)">
      <!-- Action Buttons -->
      <div class="flex space-x-10 mt-16 mb-16 items-center">
        <action-button
          v-if="permissions.persoAddNew && personalLibrary"
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-indigo-300"
          bg-color-square="bg-indigo-200"
          icon-color="text-indigo-600"
          :libelle="
            'Ajouter ' +
              (isJobDescriptionType
                ? 'une fiche de poste'
                : 'un référentiel de formation') +
              ' vierge'
          "
          icon="plus"
          @clickAction="new_desc()"
          responsive
        />
        <action-button
          v-if="permissions.commonAddNew && !personalLibrary"
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-indigo-300"
          bg-color-square="bg-indigo-200"
          icon-color="text-indigo-600"
          :libelle="
            'Ajouter ' +
              (isJobDescriptionType
                ? 'une fiche de poste'
                : 'un référentiel de formation') +
              ' vierge'
          "
          icon="plus"
          @clickAction="new_desc()"
          responsive
        />
        <action-button
          v-if="permissions.persoDownloadModel && isJobDescriptionType"
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-teal-300"
          bg-color-square="bg-teal-100"
          icon-color="text-teal-600"
          libelle="Télécharger le modèle de fiche"
          icon="download"
          @clickAction="download('/resources/', 'Modele_fiche_de_poste.doc')"
          responsive
        />
        <action-button
          v-if="permissions.persoDownloadInstructions && isJobDescriptionType"
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-pink-300"
          bg-color-square="bg-pink-100"
          icon-color="text-pink-600"
          libelle="Télécharger la notice fiche de poste"
          icon="file-text"
          @clickAction="
            download('/resources/', 'Formalisation_fiche_de_poste.pdf')
          "
          responsive
        />
      </div>

      <div
        id="jobdescs"
        class="relative flex flex-col align-middle min-w-full shadow rounded-xl bg-white min-h-screen"
      >
        <div class="flex flex-col">
          <h3 class="my-5 lg:my-15 2xl:my-20 w-full">
            {{ title }}
          </h3>
          <div class="flex items-center justify-center space-x-3">
            <div
              v-if="permissions.commonList && permissions.persoList && navBarScrolledRight"
              @click.stop="scrollLibraryTypeTab('left')"
            >
              <icon
                class="text-indigo-600 md:hidden block transform rotate-180"
                name="arrow-right_1"
              />
            </div>
            <nav
              @scroll="handleScroll"
              id="jobDescriptionLibraryTypeTabs"
              class="flex justify-between md:justify-center md:space-x-10 text-gray-600 cursor-pointer text-center overflow-x-auto w-2/3 md:w-full"
            >
              <!-- Change le style et @click en fonction de la librairie actuelle -->
              <h4
                id="tour_personal_library"
                v-if="permissions.persoList"
                @click="changeLibrary(true)"
                class="text-gray-600 flex-shrink-0 w-max cursor-pointer font-light hover:text-pink-600"
                :class="{
                  'text-indigo-600 font-normal': personalLibrary,
                }"
              >
                Bibliothèque personnelle
              </h4>

              <h4
                id="tour_shared_library"
                v-if="permissions.commonList"
                @click="changeLibrary(false)"
                class="text-gray-600 flex-shrink-0 w-max cursor-pointer font-light hover:text-pink-600 pl-4 md:pl-0"
                :class="{
                  'text-indigo-600 font-normal': !personalLibrary,
                }"
              >
                Bibliothèque commune
              </h4>
            </nav>
            <div
              v-if="permissions.commonList && permissions.persoList && !navBarScrolledRight"
              @click.stop="scrollLibraryTypeTab('right')"
            >
              <icon
                class="text-indigo-600 md:hidden block"
                name="arrow-right_1"
              />
            </div>
          </div>
        </div>

        <!-- =================================== -->

        <!-- Search menu dropdown -->
        <div class="flex flex-col items-center justify-center my-5 space-y-5">
          <div
            id="search_filter_container"
            class="flex items-center justify-between w-full px-5 mb-2"
          >
            <!-- Filter -->
            <div class="relative flex justify-start tour_fiches_postes_filtrer">
              <div class="flex justify-start items-center cursor-pointer">
                <div
                  class="flex justify-start items-center cursor-pointer"
                  @click="displayFilter"
                  @click.stop
                >
                  <div
                    class="bg-teal-300 text-teal-600 max-h-8 rounded-full inline-flex items-center p-2"
                  >
                    <icon
                      class="h-4 w-4"
                      name="height"
                    />
                  </div>
                  <div class="hidden lg:flex items-center mx-2">
                    <p class="text-lg text-gray-900 text-center select-none">
                      Filtrer les
                      {{
                        isJobDescriptionType
                          ? 'fiches de poste'
                          : 'référentiels de formation'
                      }}
                    </p>
                  </div>
                </div>
                <div
                  v-show="searchSector || searchFamily"
                  class="text-sm text-pink-600 cursor-pointer"
                  @click="clearFilters"
                >
                  Supprimer les filtres
                </div>
              </div>

              <div
                class="filterbox z-40 absolute rounded-md bg-white shadow-md shadow-gray-600 text-base top-14 py-5 pl-5 pr-8 min-w-max"
                v-if="showFilter"
                v-click-outside="displayFilter"
              >
                <div
                  class="grid grid-cols-2 gap-y-2 lg:gap-y-0 lg:gap-x-4 min-w-max"
                >
                  <input-select
                    name="sector"
                    libelle="Secteur d'activité"
                    :datas="categories"
                    @input="
                      (newValue) => {
                        searchSector = newValue;
                      }
                    "
                    class="lg:col-span-1"
                    :value="searchSector"
                  />
                  <input-select
                    name="family"
                    libelle="Famille professionnelle"
                    :datas="listFamilies"
                    @input="
                      (newValue) => {
                        searchFamily = newValue;
                      }
                    "
                    class="lg:col-span-1"
                  />
                  <input-select
                    class="lg:col-start-1"
                    name="resource"
                    libelle="Ressource"
                    :datas="[{value: 'Tout'}, {value: 'Neopass'}, {value: 'ROME'}]"
                    :value="resourceFilter"
                    @input="(newValue) => resourceFilter = newValue"
                  ></input-select>
                </div>
              </div>
            </div>

            <div
              id="search_bar_container"
              class="w-2/3 sm:w-1/3"
              @keydown="onKeyDown"
              @keyup="onKeyUp"
            >
              <!-- Search bar -->
              <search-bar
                name="searchBeneficiary"
                libelle=""
                :value="search"
                :placeholder="
                  'Rechercher ' +
                    (isJobDescriptionType ? 'une fiche' : 'un référentiel')
                "
                :big="false"
                :inherits="false"
                :has-border="false"
                @input="
                  (newValue) => {
                    search = newValue;
                  }
                "
              />
            </div>
          </div>

          <div
            id="sort_button_container"
            class="w-full px-5 flex items-center justify-end"
            @keydown="onKeyDown"
            @keyup="onKeyUp"
          >
            <sort-button
              :sort="sort"
              @sorted="
                (sortType) => {
                  sort = sortType;
                }
              "
            />
          </div>
        </div>

        <!-- =================================== -->

        <SheetList
          v-if="sortedSheets.length > 0"
          :sheets="sortedSheets"
          :personal-library="personalLibrary"
          @showSheet="([sheet, editMode]) => openModal(sheet, editMode)"
          @displayDis="restrictedDescsPopup = true"
          @export="exporter"
          @delete="showDeletePopup"
          @duplicate="duplicate"
          @import="(sheet) => addToPersonalLibrary(sheet.id)"
        />

        <div
          v-else-if="!loading && listSheets.length === 0 && hasSearch"
          class="flex flex-col justify-center items-center w-full"
        >
          <h3
            class="text-pink-600 w-full text-center font-semibold text-lg mt-12"
          >
            Aucun résultat !
          </h3>
          <h4
            class="text-indigo-600 w-4/6 inputfloat text-center text-base mt-4"
          >
            {{
              isJobDescriptionType
                ? 'Aucune fiche de poste'
                : 'Aucun référentiel de formation'
            }}
            ne correspond à votre recherche, veuillez réessayer avec de nouveaux
            éléments
          </h4>
          <div class="mt-4 mb-8">
            <illustration name="no_result" />
          </div>
        </div>
        <div
          v-else-if="!loading && listSheets.length === 0"
          class="flex flex-col justify-center items-center w-full"
        >
          <h6 class="text-pink-600 w-full text-center mt-12 mb-8">
            {{
              isJobDescriptionType
                ? 'Aucune fiche de poste'
                : 'Aucun référentiel de formation'
            }}
            !
          </h6>
          <div class="text-indigo-600 w-4/6 text-center text-base">
            Vous n'avez
            {{
              isJobDescriptionType
                ? 'aucune fiche de poste'
                : 'aucun référentiel de formation'
            }}
            <span v-if="!personalLibrary">dans votre bibliothèque commune</span>
            <span
              v-if="
                (personalLibrary &&
                  (permissions.persoAddNew || permissions.commonAddToPerso)) ||
                  (!personalLibrary && permissions.commonAddNew)
              "
            >, vous pouvez
            </span>
            <span
              v-if="
                (permissions.persoAddNew && personalLibrary) ||
                  (permissions.commonAddNew && !personalLibrary)
              "
            >en créer une nouvelle</span>
            <span
              v-if="
                personalLibrary &&
                  permissions.persoAddNew &&
                  permissions.commonAddToPerso
              "
            >
              ou</span>
            <span v-if="personalLibrary && permissions.commonAddToPerso">
              en importer depuis la bibliothèque commune</span>.
          </div>
          <div class="mt-4 mb-8">
            <illustration name="no_result" />
          </div>
        </div>
      </div>
    </div>
    <!-- display message when user not allow to use this function -->
    <page-not-allowed v-else />
  </div>
</template>

<script>
import store from '../store';
import { mapGetters, mapMutations } from 'vuex';
import axios from '../api';

import Icon from '../components/Icon';
import ActionButton from '../components/ActionButton';
import InputSelect from '../components/Inputs/InputSelect';
import Illustration from '../components/Illustration';

import JsFileDownload from 'js-file-download';
import ClickOutside from 'vue-click-outside';

import ModuleHeader from '../components/ModuleHeader.vue';
import SortButton from './../components/SortButton';
import SearchBar from '../components/Inputs/SearchBar.vue';

import Popup from '../components/Popup';
import PageNotAllowed from '../components/PageNotAllowed';
import PopupJobDesc from '../components/PopupJobDesc';
import PopupRomeDesc from '../components/PopupRomeDesc';
import PopupRefFormation from './../components/PopupRefFormation.vue';
import ConfirmDeletePopup from './../components/Popups/ConfirmDeletePopup.vue';

import Constants from './../constants';
import SheetList from './SheetList.vue';
export default {
  components: {
    SheetList,
    Icon,
    ActionButton,
    InputSelect,
    PageNotAllowed,
    Popup,
    Illustration,
    PopupJobDesc,
    PopupRomeDesc,
    SortButton,
    ConfirmDeletePopup,
    ModuleHeader,
    SearchBar,
    PopupRefFormation,
  },

  name: 'FicheDePoste',

  data() {
    return {
      idJob: '',
      shownJobId: null,
      showJobDesc: false,
      showRefForm: false,
      showRomeDesc: false,
      openFromEditButton: Boolean,
      categories: [],
      //descs: [],
      success: false, //Détermine si il faut afficher un message lors d'un ajout depuis la bibli commune
      search: '',
      listSheets: [],
      searchSector: '',
      searchFamily: '',
      showFilter: false,
      showList: false,
      smallBar: false,
      confirmDeleteDesc: -1,
      toDelete: null,
      displayedEditInfoBulle: 0,
      displayedDeleteInfoBulle: 0,
      transferSuccess: false,
      transferedDesc: '',
      postesCount: 0,
      sort: 'ABC',
      isDisplayAddToMyLibraryTooltip: false,
      constants: Constants,
      urlCursor: '',
      navBarScrolledRight: false,
      restrictedDescsPopup: false,
      resourceFilter: 'Tout',

      searchTypingInterval: 500,
      positionLibraryTypeTab: 0,
      scrollMaxLibraryTypeTab: 1920,
    };
  },

  async beforeMount() {
    await this.load_descs(true);
    await this.load_sectors();
    await this.load_domaines();
  },

  mounted() {
    if (!this.permissions.persoList) {
      if (this.permissions.commonList) {
        this.personalLibrary = false;
        this.$parent.bibliCommune = true;
      }
    }

    if (this.$route.params) {
      if (this.$route.params.action === 'newDesc') {
        this.new_desc();
      } else if (this.$route.params.action === 'common') {
        this.personalLibrary = false;
      }
    }

    this.getNextJobDescOnScroll();

    let libraryTypeTab = document.getElementById(
      'jobDescriptionLibraryTypeTabs'
    );
    this.scrollMaxLibraryTypeTab = libraryTypeTab.scrollLeftMax;
  },

  watch: {
    searchSector(val) {
      this.load_descs(true);
    },

    searchFamily(val) {
      this.load_descs(true);
    },

    resourceFilter() {
      this.load_descs(true);
    }
  },

  computed: {
    ...mapGetters({
      allowed: 'app/allowed',
      personalLibrary: 'jobDescription/personalLibrary',
      loading: 'app/loading',
    }),
    hasSearch() {
      return (
        this.search.length > 0 ||
        this.searchFamily.length > 0 ||
        this.searchSector.length > 0
      );
    },

    title() {
      return this.isJobDescriptionType
        ? 'Fiches de poste'
        : 'Référentiels de formation';
    },

    canExport() {
      return this.permissions.persoExport;
    },

    canDelete() {
      return this.permissions.persoDelete && this.personalLibrary;
    },

    canEdit() {
      return this.permissions.persoEdit && this.personalLibrary;
    },

    canView() {
      return this.permissions.persoRead && this.personalLibrary;
    },
    /**
     * Define type page by route path (JobDescription or ReferentielFormation)
     */
    isJobDescriptionType() {
      return this.$route.name == 'JobDescription';
    },

    permissions() {
      return {
        persoEdit:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
            )),
        persoList:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_LISTE)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_LISTE
            )),
        commonList:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_LISTE)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_LISTE
            )),
        persoAddNew:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_AJOUTER_FICHE
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_AJOUTER_FICHE
            )),
        commonAddNew:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_AJOUTER_FICHE
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_AJOUTER_FICHE
            )),
        persoExport:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EXPORTER
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EXPORTER
            )),
        persoDelete:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_SUPPRIMER
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_SUPPRIMER
            )),
        persoRead:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_CONSULTER
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_CONSULTER
            )),
        persoDownloadModel:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_TELECHARGER_MODELE
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_TELECHARGER_MODELE
            )),
        persoDownloadInstructions:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_TELECHARGER_INSTRUCTIONS
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_TELECHARGER_INSTRUCTIONS
            )),
        commonExport:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_EXPORTER)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_EXPORTER
            )),
        commonDelete:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_SUPPRIMER)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_SUPPRIMER
            )),
        commonEdit:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_EDITER)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_EDITER
            )),
        commonRead:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_CONSULTER)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_CONSULTER
            )),
        commonAddToPerso:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_AJOUTER_DANS_BIBLIOTHEQUE_PERSONNELLE
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_AJOUTER_DANS_BIBLIOTHEQUE_PERSONNELLE
            )),
      };
    },

    /**
     * List families generated by category field in filter
     */
    listFamilies() {
      if (this.searchSector == '' || this.searchSector === null) {
        this.allFamilies = [];
        for (let cat in this.categories) {
          for (let st in this.categories[cat].families) {
            this.allFamilies.push({
              value: this.categories[cat].families[st].value,
            });
          }
        }
        this.allFamilies.sort(function (a, b) {
          if (a.value > b.value) {
            return 1;
          } else if (a.value < b.value) {
            return -1;
          } else {
            return 0;
          }
        });
        return this.allFamilies;
      } else {
        return [
          ...((
            this.categories.filter((v) => v.value == this.searchSector)[0] || {}
          ).families || []),
          ...((
            this.categories.filter((v) => v.value == this.searchSector)[0] || {}
          ).domaines || []),
        ];
      }
    },

    orderBy() {
      switch (this.sort) {
      case 'ABC':
      case 'ZYX':
        return 'name';

      case 'JAN':
      case 'DEC':
        return 'created_at';
      default:
        return 'name';
      }
    },

    direction() {
      switch (this.sort) {
      case 'ABC':
      case 'JAN':
        return 'ASC';

      case 'ZYX':
      case 'DEC':
        return 'DESC';
      default:
        return 'ASC';
      }
    },

    sortedSheets() {
      const isAscDirection = this.direction === 'ASC';
      const getSortingFactor = (isAscending) => isAscending ? 1 : -1;

      let romes = this.listSheets.filter((sheet) => sheet.type === 'rome');
      let rest = this.listSheets.filter((sheet) => sheet.type !== 'rome');

      const sort = (first, second) => {
        let [firstValue, secondValue] = [first[this.orderBy], second[this.orderBy]];

        if (typeof firstValue === 'string') {
          firstValue = firstValue.toLowerCase();
        }

        if (typeof secondValue === 'string') {
          secondValue = secondValue.toLowerCase();
        }

        if (firstValue > secondValue) {
          return getSortingFactor(isAscDirection);
        } else if (secondValue > firstValue) {
          return getSortingFactor(!isAscDirection);
        }
        return 0;
      };

      // If we need to sort the different types of sheets individually
      /*romes = romes.sort(sort);
      rest = rest.sort(sort);
      return [...rest, ...romes];
      */

      return [...this.listSheets].sort(sort).filter((sheet) => {
        if (this.resourceFilter === 'Tout') return true;
        if (this.resourceFilter === 'Neopass') {
          return sheet.type === 'job_desc';
        }
        if (this.resourceFilter === 'ROME') {
          return sheet.type === 'rome';
        }
      });

      /*return [...this.listSheets].sort((first, second) => {
        let [firstValue, secondValue] = [first[this.orderBy], second[this.orderBy]];

        if (typeof firstValue === 'string') {
          firstValue = firstValue.toLowerCase();
        }

        if (typeof secondValue === 'string') {
          secondValue = secondValue.toLowerCase();
        }

        if (firstValue > secondValue) {
          return getSortingFactor(isAscDirection);
        } else if (secondValue > firstValue) {
          return getSortingFactor(!isAscDirection);
        }
        return 0;
      });*/
    }
  },

  methods: {
    /**
     * Function to handle scroll event.
     *
     * @param {Event} event - The scroll event.
     * @return {undefined}
     */
    handleScroll(event) {
      this.navBarScrolledRight = event.target.scrollLeft > event.target.getBoundingClientRect().width / 2;
    },

    scrollLibraryTypeTab(direction) {
      let libraryTypeTab = document.getElementById(
        'jobDescriptionLibraryTypeTabs'
      );

      if (!libraryTypeTab) return;

      let positionX = direction === 'left' ? 0 : libraryTypeTab.scrollLeftMax;
      libraryTypeTab.scroll({
        top: 0,
        left: positionX,
        behavior: 'smooth',
      });
    },

    actionColumnTitle() {
      if (this.personalLibrary) {
        let verb = this.permissions.persoEdit ? 'Modifier ' : 'Visualiser ';
        let subject = this.isJobDescriptionType ? 'la fiche' : 'le référentiel';
        return verb + subject;
      } else {
        return 'Ajouter à ma bibli.';
      }
    },

    tagStyle(sheet) {
      const neopassTypeSheet = ['job_desc', 'sheet', 'ref_formation'].includes(
        sheet.type
      );
      return {
        label: neopassTypeSheet ? 'Neopass' : 'Rome',
        color: neopassTypeSheet ? 'pink' : 'indigo',
      };
    },

    async duplicate(desc) {
      store.commit('app/SET_LOADING', true);

      try {
        await axios.get(`api/sheets/clone/${desc.id}`);
        //TODO: display success message
        await this.load_descs(true);
      } catch (error) {
        if (error.response.data === 'sheet cap') {
          alert('Vous avez atteint le maximum de fiches de postes autorisé par votre abonnement.');
        }
        //TODO: display error message
      } finally {
        store.commit('app/SET_LOADING', false);
      }
    },

    changeLibrary(pub) {
      this.SET_PERSONALLIBRARY(pub);
      this.clearFilters();
      this.load_descs(true);
      this.$parent.bibliCommune = !pub;
    },

    onKeyDown() {
      clearTimeout(this.timer);
    },

    onKeyUp() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.doneTyping, this.searchTypingInterval);
    },

    doneTyping() {
      this.load_descs(true);
    },

    ...mapMutations({
      SET_PERSONALLIBRARY: 'jobDescription/SET_PERSONALLIBRARY',
    }),

    /**
     * Show confirm delete popup with job description informations
     * @param Object desc
     */
    async showDeletePopup(desc) {
      store.commit('app/SET_LOADING', true);
      await axios
        .get('api/work_station/descs/' + desc.id)
        .then((response) => {
          this.postesCount = response.data;
          this.toDelete = desc;
          store.commit('app/SET_LOADING', false);
          this.confirmDeleteDesc = 0;
        })
        .catch((error) => {
          console.log('ERRR:' + error);
          store.commit('app/SET_LOADING', false);
        });
    },

    /**
     * Display a tooltip when hover edit/delete button and haven't edit rights
     * @param Object jobDescription
     * @param String type
     */
    displayInfoBulleNoEdit(jobDescription, type) {
      switch (type) {
      case 'edit':
        this.displayedEditInfoBulle = jobDescription.id;
        break;
      case 'delete':
        this.displayedDeleteInfoBulle = jobDescription.id;
        break;
      default:
        break;
      }
    },

    /**
     * hide all tooltip when mouse leave button
     */
    hideInfoBulleEvaluationEnCours() {
      this.displayedEditInfoBulle = 0;
      this.displayedDeleteInfoBulle = 0;
    },

    /**
     * Download file
     * @param String rep
     * @param String file
     */
    download(rep, file) {
      axios({ url: rep + file, method: 'GET', responseType: 'blob' }).then(
        (response) => {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', file);
          document.body.appendChild(fileLink);

          fileLink.click();
        }
      );
    },

    /**
     * delete the job description
     * @param Object jobDesc
     */
    async deleteDesc(jobDesc) {
      if (this.permissions.persoDelete && jobDesc !== null) {
        store.commit('app/SET_LOADING', true);
        await axios
          .delete('/api/sheets/' + jobDesc.id)
          .then((response) => {
            this.confirmDeleteDesc = 1;
            this.load_descs(true);
          })
          .catch((error) => console.log('ERRRR::', error));
      }
      store.commit('app/SET_LOADING', false);
    },

    /**
     * Reset all filters
     */
    clearFilters() {
      this.search = '';
      this.searchSector = '';
      this.searchFamily = '';
    },

    /**
     * Display categories and families filter fields
     */
    displayFilter() {
      this.showFilter = !this.showFilter;
    },

    /**
     * Retrieve job description datas by Library type
     * @param Boolean resetNumPage
     */
    async load_descs(resetNumPage = false) {
      console.log('wait...load descs');

      if (resetNumPage) {
        //for example, when create a new job desc, reset the job desc list
        this.urlCursor = '';
        this.listSheets = [];
      }

      //urlCursor become null when there is not next Cursor (end of the list)
      if (this.urlCursor === null) {
        return;
      }

      let templateType = this.isJobDescriptionType
        ? 'job_desc'
        : 'ref_formation';

      templateType = this.$freeParticulier() ? 'rome' : templateType;

      store.commit('app/SET_LOADING', true);

      let options = {
        search: this.search,
        sector: this.searchSector,
        family: this.searchFamily,
        orderBy: this.orderBy,
        direction: this.direction,
        resource: this.resourceFilter,
        wantEvaluationUsed: true,
      };

      let url;
      if (this.personalLibrary) {
        //Bibliothèque perso
        url = `/api/sheets/listByType/${templateType}?paginated=1&cursor=${this.urlCursor}`;
      } else {
        // Bibliothèque commune
        url = `/api/sheets/listByType/${templateType}/0?paginated=1&cursor=${this.urlCursor}`;
      }

      let listSheetBefore =
        this.listSheets && this.urlCursor != '' ? [...this.listSheets] : [];
      try {
        let {
          data: { nextCursor: nextCursor, sheets: sheets },
        } = await axios.post(url, options);
        this.listSheets = [...listSheetBefore, ...sheets.data];
        this.urlCursor = nextCursor; // get new cursor page
      } catch (error) {
        console.log('ERRRR:: ', error);
      } finally {
        store.commit('app/SET_LOADING', false);
      }
    },

    /**
     * Load all sectors for Neopass job descriptions
     */
    async load_sectors() {
      await axios
        .get('api/datatype/sectors')
        .then((response) => {
          let sectors = response.data.data.map((sector) => ({
            ...sector,
            group:
              '1. Secteurs ' +
              (this.isJobDescriptionType
                ? 'fiche de poste Neopass'
                : 'référentiel de formation'),
          }));
          this.categories = [...this.categories, ...sectors];
        })
        .catch((error) => {
          console.log('load_sectors ERRRR:: ', error);
        });
    },

    /**
     * Load all sectors for ROME job description
     */
    async load_domaines() {
      await axios
        .get('api/datatype/domaines')
        .then((response) => {
          let domaines = response.data.data.map((domaine) => ({
            ...domaine,
            group: '2. Secteurs fiche ROME',
          }));
          this.categories = [...this.categories, ...domaines];
        })
        .catch((error) => {
          console.log('ERRRR:: ', error.response);
        });
    },

    /**
     * Create a new job description and open popup to edit it
     */
    async new_desc() {
      if (this.permissions.persoAddNew) {
        store.commit('app/SET_LOADING', true);

        let templateType = this.isJobDescriptionType
          ? 'job_desc'
          : 'ref_formation';

        await axios
          .put('/api/sheets/add/' + templateType)
          .then((response) => {
            store.commit('app/SET_LOADING', false);
            this.success = true;
            this.load_descs(true);
            this.openModal(response.data, true);
          })
          .catch((error) => {
            console.log('ERRRR::', error);
            if (error.response.data === 'sheet cap') {
              alert('Vous avez atteint le maximum de fiches de postes autorisé par votre abonnement.');
            }

            store.commit('app/SET_LOADING', false);
          });
      }
    },

    /**
     * Duplicate common library job description into personnal library
     * @param Number id
     */
    async addToPersonalLibrary(id) {
      if (this.permissions.commonAddToPerso) {
        store.commit('app/SET_LOADING', true);
        await axios
          .get('/api/sheets/transfer/' + id)
          .then((response) => {
            this.transferSuccess = true;
            this.transferedDesc = this.listSheets.filter(
              (desc) => desc.id === id
            )[0].name;
            store.commit('app/SET_LOADING', false);
          })
          .catch((error) => {
            if (error.response.data === 'sheet cap') {
              alert('Vous avez atteint le maximum de fiches de postes autorisé par votre abonnement.');
            } else {
              console.log('ERRRR::', error.response.data);
            }
            store.commit('app/SET_LOADING', false);
          });
      }
    },

    /**
     * Retrieve all form datas and display it in edit job description popup
     * @param Number descId
     * @param Boolean edit
     * @param Boolean rome
     */
    openModal(desc, edit) {
      let descId = desc.id;

      if (String(descId) === 'new_common' && !this.permissions.commonAddNew) {
        return false;
      }
      if (String(descId) === 'new_personnal' && !this.permissions.persoAddNew) {
        return false;
      }
      store.commit('app/SET_LOADING', true);

      this.openFromEditButton = edit;
      this.showJobDesc = desc.type == 'job_desc';
      this.showRefForm = desc.type == 'ref_formation';
      this.showRomeDesc = desc.type == 'rome';
      this.shownJobId = descId;
      this.showFilter = false;
      this.searchSector = '';

      store.commit('app/SET_LOADING', false);
    },

    /**
     * Display specific page or hide confirm delete popup
     * @param Number val
     */
    changeDeletePopupState(val) {
      this.confirmDeleteDesc = val;

      if (val == -1) {
        this.toDelete = null;
      }
    },

    /**
     * Display or hide transfer success popup
     * @param Boolean val
     */
    changeTransferSuccessPopupState(val) {
      this.transferSuccess = val;
    },

    /**
     * Export job description into PDF
     * @param Object desc
     */
    async exporter(desc) {
      let type = '';

      switch (desc.type) {
      case 'ref_formation':
        type = 'refFormation';
        break;
      case 'job_desc':
        type = 'desc';
        break;
      case 'rome':
        type = 'rome';
        break;
      default:
        return;
      }

      await axios({
        url: '/api/pdf/' + type + '/' + desc.id,
        method: 'get',
        responseType: 'blob', // Important
      }).then((response) => {
        JsFileDownload(
          response.data,
          `${desc.data.nom_du_poste} - ${new Date().toLocaleDateString()}.pdf`
        );
      });
    },

    /**
     * Pagination with infinite scroll
     */
    getNextJobDescOnScroll() {
      let mainContent = document.getElementById('main-content');

      mainContent.onscroll = () => {
        let bottomOfWindow =
          mainContent.scrollTop + mainContent.offsetHeight ===
          mainContent.scrollHeight;
        console.log(bottomOfWindow  );

        if (bottomOfWindow && this.$route.name === 'JobDescription') {
          this.load_descs(false);
        }
      };
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
